import { RenewalConfirmationTranslations } from '../types';

export const renewalConfirmation: RenewalConfirmationTranslations = {
  title: "Renewal Confirmed!",
  subtitle: "Thank you for renewing your trust in Gándara International School",

  // Submission Details
  submissionDetails: "Your Renewal Details",
  parentName: "Parent/Guardian",
  childrenEnrolled: "Children Enrolled",
  submissionDate: "Application Date",
  referenceNumber: "Reference Number",

  // Payment Instructions
  paymentInstructions: "Payment Instructions",
  bankAccount: "Bank Account",
  accountNumber: "ES70 2100 5752 6202 0018 6824",
  recipient: "Recipient",
  recipientName: "NOGUERA Y VALDES SL",
  concept: "Payment Concept",
  amount: "Amount to Transfer",
  deadline: "Payment Deadline",
  earlyBirdDeadline: "February 28, 2026 (early bird discount)",
  standardDeadline: "March 17, 2026",

  // Pricing Breakdown
  pricingBreakdown: "Cost Breakdown",
  matriculaTotal: "Total Enrollment",
  annualTuitionTotal: "Total Annual Tuition (10 months)",
  earlyBirdDiscount: "Early Bird Discount",
  annualPaymentDiscount: "Annual Payment Discount",
  grandTotal: "Grand Total",

  // Next Steps
  nextSteps: "Next Steps",
  steps: {
    transfer: "Make the bank transfer with the details indicated above. Don't forget to include the exact concept so we can identify your payment.",
    sendConfirmation: "Send payment confirmation to info@gandaraschool.com",
    receiptConfirmation: "We will confirm receipt of your payment within 2 business days",
    welcomeEmail: "You will receive a welcome email in June with all the information for the start of the 2026/2027 school year"
  },

  // Contact Info
  contactInfo: "Contact Information",
  questionsContact: "Do you have any questions? We're here to help:",

  // Actions
  printConfirmation: "Print Confirmation",
  backToHome: "Back to Home"
};
